import React, { useState } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: any
}

const ModalBody: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  const [isClosing, setIsClosing] = useState(false);

  return (
    <>
      {isOpen && (
        <div className={`custom-modal--Pricing ${isClosing ? "closing" : ""}`}>
          <div className="custom-modal--PricingContent">{children}</div>
        </div>
      )}
    </>
  );
};

export default ModalBody;
